import axios from 'axios'
import { ENVIAR_FECHAMENTO_CAIXA } from '../../types'
import { SLOW_REQUEST_CONFIG } from '../../../util/loadingUtil'
import { URL } from '../../../util/ambienteActions';

export default function enviarFechamentoCaixa (codigoEmpresa, parametros) {
  const url = `${URL}/fechamento-caixa-usuario/empresa/${codigoEmpresa}/enviar`;
  return dispatch => axios.post(url,parametros , SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: ENVIAR_FECHAMENTO_CAIXA,
        payload: response
      })
  );
}
